import React from 'react';
import { LoadingSkeletonProps } from '../Base/Base';
import { useResponsiveValue } from '../../hooks/useResponsiveValue';
import { styles } from './Shimmer.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export const Shimmer = ({
  shouldShimmer: shouldShimmerProp = true,
  className,
}: Pick<LoadingSkeletonProps, 'shouldShimmer'> & { className?: string }) => {
  const shouldShimmer = useResponsiveValue(shouldShimmerProp);
  return <div className={classNames([styles.shimmer({ shouldShimmer }), className])} />;
};
